import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const SharpThreeQuarterStar: FunctionalComponent<IIconProps> = ({
  width = '24',
  height = '24',
  strokeWidth = 1.6,
  fill = '#FAC627',
  stroke = '#8D6708',
}) => (
  /*@ts-ignore*/
  <svg viewBox="0 0 24 24" width={width} height={height} fill="none" strokeWidth={strokeWidth}>
    {/*@ts-ignore*/}
    <g clipPath="url(#clip0.75)">
      {/*@ts-ignore*/}
      <mask id="mask0.75" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="1" width="24" height="22">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 19L4.94658 22.7082L6.29366 14.8541L0.587322 9.2918L8.47329 8.1459L12 1L15.5267 8.1459L23.4127 9.2918L17.7063 14.8541L19.0534 22.7082L12 19Z"
          fill="#F5F5F5"
        />
      </mask>
      {/*@ts-ignore*/}
      <g mask="url(#mask0.75)">
        <rect width="15" height="22" fill={fill} />
        <path
          d="M12.2328 18.5574L12.0001 18.4351L11.7674 18.5574L5.61072 21.7942L6.78655 14.9386L6.83098 14.6795L6.64275 14.4961L1.66188 9.64092L8.54527 8.6407L8.8054 8.6029L8.92174 8.36718L12.0001 2.12978L15.0784 8.36718L15.1948 8.6029L15.4549 8.6407L22.3383 9.64092L17.3574 14.4961L17.1692 14.6795L17.2136 14.9386L18.3894 21.7942L12.2328 18.5574Z"
          stroke={stroke}
        />
      </g>
    </g>
    {/*@ts-ignore*/}
    <defs>
      {/*@ts-ignore*/}
      <clipPath id="clip0.75">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SharpThreeQuarterStar;
